import { computed } from 'vue'

import DeviceInfo from '@shared/plugins/device-info'
import { useVideoCallConfigsStore } from '@shared/store/video-call-configs'
import { SUPPORTED_BROWSERS } from '@shared/utils/constants/video-call-configs'
import { isMobileDevice } from '@shared/utils/helpers/is-mobile-device'

export const useScreenSharing = () => {
  const videoCallConfigsStore = useVideoCallConfigsStore()

  const isScreenSharingMode = computed(
    () => videoCallConfigsStore.isScreenSharingMode
  )

  const isUserShareScreen = computed(
    () => videoCallConfigsStore.isScreenSharing
  )

  const isActiveScreenSharing = computed(
    () => videoCallConfigsStore.screenShareInProgress
  )

  const isScreenSharingAllowed = computed(() => {
    return (
      SUPPORTED_BROWSERS.some((browser) => DeviceInfo.isBrowser(browser)) &&
      !isMobileDevice()
    )
  })

  return {
    isUserShareScreen,
    isScreenSharingMode,
    isScreenSharingAllowed,
    isActiveScreenSharing,
  }
}
